// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oh {\n  display: inline-block;\n}\n.oh table td {\n  text-align: left;\n  vertical-align: top;\n}\n.oh table td:first-child {\n  padding-right: 0.5vw;\n}", ""]);
// Exports
module.exports = exports;
